import React, { useEffect, useState } from "react";
import RootAdmin from "../../../../components/layouts/RootAdmin";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableColumn,
  TableHeader,
  TableRow,
} from "@nextui-org/react";
import HeaderPage from "../../../../components/elements/HeaderPage";
import { BarChart } from "@mui/x-charts/BarChart";
import useSWR from "swr";
import { getFetcher, HIGHCHART_URL } from "../../../../services/api";
import FilterInTab from "../../../../components/elements/FilterInTab";
import { translateMonth } from "../../../../services/helpers";
import Highcharts from "highcharts";
import HighchartsReact from 'highcharts-react-official';
import highchartsExporting from 'highcharts/modules/exporting';
import { isiSel, kelasKolom, kelasKolomDariData } from "../../../../services/angkaTabel";

// Initialize Highcharts exporting modules
highchartsExporting(Highcharts);

export default function DistribusiGrafik() {
  const currentDate = new Date();
  const defaultMonth = currentDate.getMonth() + 1;
  const defaultYear = currentDate.getFullYear();

  // Bawaan lama adalah bulan berjalan saja (mis. September-September), dan
  // bulan berjalan hampir selalu belum ada laporannya - dasbor terlihat kosong
  // padahal datanya ada. Bawaan sekarang: awal tahun sampai bulan berjalan.
  const bulanAwalBawaan = 1;

  const [filters, setFilters] = useState({
    bahanB3BulanTahun: { month: defaultMonth, year: defaultYear },
    bahanB3Tahun: { year: defaultYear },
    perusahaanBulanTahun: { month: defaultMonth, year: defaultYear },
    perusahaanTahun: { year: defaultYear },
    customerTahun: { year: defaultYear },
    provinsiTahun: { year: defaultYear },
    provinsiDistribusiTahun: { year: defaultYear },
  });

  const updateFilter = (key, newFilter) => {
    setFilters((prev) => ({
      ...prev,
      [key]: { ...prev[key], ...newFilter },
    }));
  };

  // Fetch data untuk setiap tab
  const { data: bahanB3BulanTahun, mutate: mutateBahanB3BulanTahun } = useSWR(
    `/api/dashboard/pelaporan/distribusi/grafik/bahan-b3-by-month-year?startMonth=${filters.bahanB3BulanTahun.startMonth || bulanAwalBawaan}&startYear=${filters.bahanB3BulanTahun.startYear || defaultYear}&endMonth=${filters.bahanB3BulanTahun.endMonth || defaultMonth}&endYear=${filters.bahanB3BulanTahun.endYear || defaultYear}`,
    getFetcher
  );

  const { data: bahanB3Tahun, mutate: mutateBahanB3Tahun } = useSWR(
    `/api/dashboard/pelaporan/distribusi/grafik/bahan-b3-by-year?year=${filters.bahanB3Tahun.year}`,
    getFetcher
  );

  const { data: perusahaanBulanTahun, mutate: mutatePerusahaanBulanTahun } = useSWR(
    `/api/dashboard/pelaporan/distribusi/grafik/company-by-month-year?startMonth=${filters.perusahaanBulanTahun.startMonth || bulanAwalBawaan}&startYear=${filters.perusahaanBulanTahun.startYear || defaultYear}&endMonth=${filters.perusahaanBulanTahun.endMonth || defaultMonth}&endYear=${filters.perusahaanBulanTahun.endYear || defaultYear}`,
    getFetcher
  );

  const { data: perusahaanTahun, mutate: mutatePerusahaanTahun } = useSWR(
    `/api/dashboard/pelaporan/distribusi/grafik/company-by-year?year=${filters.perusahaanTahun.year}`,
    getFetcher
  );

  const { data: customerTahun, mutate: mutateCustomerTahun } = useSWR(
    `/api/dashboard/pelaporan/distribusi/grafik/customers-by-year?year=${filters.customerTahun.year}`,
    getFetcher
  );

  const { data: provinsiTahun, mutate: mutateProvinsiTahun } = useSWR(
    `/api/dashboard/pelaporan/distribusi/grafik/provinces-by-year?year=${filters.provinsiTahun.year}`,
    getFetcher
  );

  const { data: provinsiDistribusiTahun, mutate: mutateProvinsiMelakukanDistribusi } = useSWR(
    `/api/dashboard/pelaporan/distribusi/grafik/company-distributing-provinces-by-year?year=${filters.provinsiDistribusiTahun.year}`,
    getFetcher
  );

  useEffect(() => {
    mutateBahanB3BulanTahun();
  }, [filters.bahanB3BulanTahun]);

  useEffect(() => {
    mutateBahanB3Tahun();
  }, [filters.bahanB3Tahun]);

  useEffect(() => {
    mutatePerusahaanBulanTahun();
  }, [filters.perusahaanBulanTahun]);

  useEffect(() => {
    mutatePerusahaanTahun();
  }, [filters.perusahaanTahun]);
  
  useEffect(() => {
    mutateCustomerTahun();
  }, [filters.customerTahun]);
  
  useEffect(() => {
    mutateProvinsiTahun();
  }, [filters.provinsiTahun]);

  useEffect(() => {
    mutateProvinsiMelakukanDistribusi();
  }, [filters.provinsiDistribusiTahun]);

  return (
    <RootAdmin>
      <HeaderPage title="Grafik Distribusi B3" subtitle="Gambaran Umum" />
      <div className="grid grid-rows-1 md:grid-rows-4 gap-3 pt-5">
        <Card>
          <Tabs aria-label="Distribusi B3" defaultValue="bahanB3BulanTahun">
            {/* Tab Bahan B3 Per Bulan Tahun */}
            <Tab title="Bahan B3 Per Bulan Tahun" value="bahanB3BulanTahun">
              <FilterInTab
                filters={filters.bahanB3BulanTahun}
                onApply={(newFilters) => updateFilter("bahanB3BulanTahun", newFilters)}
                disableMonth={false}
              />
              {renderChartAndTableForRealisasi(
                bahanB3BulanTahun?.responseData?.bahanB3,
                "Bahan B3 Per Bulan Tahun",
                ["Bulan", "Tahun", "Nomor CAS", "Nama Bahan Kimia", "Jumlah Distribusi (Kg)"],
                ["periode_bulan", "periode_tahun", "cas_number", "nama_bahan_kimia", "total_distributed"],
                "periode_bulan",
                "jumlah_distribusi"
              )}
            </Tab>

            {/* Tab Bahan B3 Per Tahun */}
            <Tab title="Bahan B3 Per Tahun" value="bahanB3Tahun">
              <FilterInTab
                filters={filters.bahanB3Tahun}
                onApply={(newFilters) => updateFilter("bahanB3Tahun", newFilters)}
                disableMonth={true}
              />
              {renderChartAndTableForRealisasi(
                bahanB3Tahun?.responseData?.bahanB3,
                "Bahan B3 Per Tahun",
                ["Tahun", "Nomor CAS", "Nama Bahan Kimia", "Jumlah Distribusi (Kg)"],
                ["periode_tahun", "cas_number", "nama_bahan_kimia", "total_distributed"],
                "nama_bahan_kimia",
                "total_distributed"
              )}
            </Tab>

            {/* Tab Perusahaan Per Bulan Tahun */}
            <Tab title="Perusahaan Per Bulan Tahun" value="perusahaanBulanTahun">
              <FilterInTab
                filters={filters.perusahaanBulanTahun}
                onApply={(newFilters) => updateFilter("perusahaanBulanTahun", newFilters)}
                disableMonth={false}
              />
                {renderMonthYearComparisonChartAndTable(
                    perusahaanBulanTahun?.responseData?.companies,
                    "Grafik Distribusi Perusahaan Per Bulan Tahun",
                    [ "Tahun", "Bulan", "Nama Perusahaan",  "Jumlah Distribusi"],
                    [ "periode_tahun", "periode_bulan", "company_name", "total_distributed"],
                    "company_name", // X-Axis (Nama Perusahaan)
                    "total_distributed" // Nilai yang diplot
                )}
            </Tab>

            {/* Tab Perusahaan Per Tahun */}
            <Tab title="Perusahaan Per Tahun" value="perusahaanTahun">
              <FilterInTab
                filters={filters.perusahaanTahun}
                onApply={(newFilters) => updateFilter("perusahaanTahun", newFilters)}
                disableMonth={true}
              />
              {renderChartAndTableForRealisasi(
                perusahaanTahun?.responseData?.companies,
                "Grafik Distribusi Perusahaan Per Tahun",
                [ "Tahun", "Nama Perusahaan",  "Jumlah Distribusi (Kg)"],
                [ "periode_tahun",  "company_name", "total_distributed"],
                "company_name", // X-Axis (Nama Perusahaan)
                "total_distributed" // Nilai yang diplot
              )}
            </Tab>

            {/* Tab Perusahaan Per Tahun */}
            <Tab title="Customer Per Tahun" value="perusahaanTahun">
              <FilterInTab
                filters={filters.customerTahun}
                onApply={(newFilters) => updateFilter("customerTahun", newFilters)}
                disableMonth={true}
              />
              {renderChartAndTableForRealisasi(
                customerTahun?.responseData?.companies,
                "Grafik Distribusi Perusahaan Per Tahun",
                [ "Tahun", "Nama Perusahaan",  "Jumlah Distribusi (Kg)"],
                [ "periode_tahun",  "customer_name", "total_distributed"],
                "customer_name", // X-Axis (Nama Perusahaan)
                "total_distributed" // Nilai yang diplot
              )}
            </Tab>

            {/* Tab Perusahaan Per Tahun */}
            <Tab title="Provinsi Tujuan Distribusi Per Tahun" value="provinsiTahun">
              <FilterInTab
                filters={filters.provinsiTahun}
                onApply={(newFilters) => updateFilter("provinsiTahun", newFilters)}
                disableMonth={true}
              />
              {renderChartAndTableForRealisasi(
                provinsiTahun?.responseData?.companies,
                "Grafik Distribusi Perusahaan Per Tahun",
                [ "Tahun", "Provinsi",  "Jumlah Distribusi (Kg)"],
                [ "periode_tahun",  "province_name", "total_distributed"],
                "province_name", // X-Axis (Nama Perusahaan)
                "total_distributed" // Nilai yang diplot
              )}
            </Tab>

            {/* Tab Perusahaan Per Tahun */}
            <Tab title="Provinsi Asal Distribusi Per Tahun" value="provinsiDistribusiTahun">
              <FilterInTab
                filters={filters.provinsiDistribusiTahun}
                onApply={(newFilters) => updateFilter("provinsiDistribusiTahun", newFilters)}
                disableMonth={true}
              />
              {renderChartAndTableForRealisasi(
                provinsiDistribusiTahun?.responseData?.provinces,
                "Grafik Provinsi Asal Distribusi Per Tahun",
                [ "Tahun", "Provinsi",  "Jumlah Distribusi (Kg)"],
                [ "periode_tahun",  "province_name", "total_distributed"],
                "province_name", // X-Axis (Nama Perusahaan)
                "total_distributed" // Nilai yang diplot
              )}
            </Tab>
          </Tabs>
        </Card>
      </div>
    </RootAdmin>
  );
}

// function renderChartAndTableForRealisasi(data, title, columns, dataKeys, dataGraphSeries, dataGraphxAxis) {
//   const safeData = Array.isArray(data) ? data : [];
//   return (
//     <>
//       <Card radius="sm" className="col-span-4">
//         <CardHeader>
//           <span className="text-primary text-xl font-bold">{title}</span>
//         </CardHeader>
//         <CardBody className="w-full flex flex-col items-center py-5 text-center">
//           <BarChart
//             xAxis={[
//               {
//                 scaleType: "band",
//                 data: safeData?.map((item) => item[dataGraphSeries] || "N/A"),
//                 label: columns[0],
//                 barGapRatio: 0,
//                 categoryGapRatio: 0.4,
//               },
//             ]}
//             series={[
//               {
//                 data: safeData?.map((item) => item[dataGraphxAxis] || 0),
//               },
//             ]}
//             height={300}
//           />
//         </CardBody>
//       </Card>
//       <div className="col-span-4 mt-5">
//         <Table aria-label="Data Table">
//           <TableHeader>
//             {columns.map((col, idx) => (
//               <TableColumn key={idx}>{col}</TableColumn>
//             ))}
//           </TableHeader>
//           <TableBody>
//             {safeData?.map((item, index) => (
//               <TableRow key={index}>
//                 {dataKeys.map((key, idx) => (
//                   <TableCell key={idx}>
//                   {key === "periode_bulan" 
//                       ? translateMonth(item[key]) || "N/A" 
//                       : item[key] || "N/A"}
//                     </TableCell>
//                 ))}
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </div>
//     </>
//   );
// }

function renderChartAndTableForRealisasi(data, title, columns, dataKeys, dataGraphSeries, dataGraphxAxis) {
  const safeData = Array.isArray(data) ? data : [];

  // Urutkan data berdasarkan nilai X-axis
  const sortedData = safeData.sort((a, b) => (b[dataGraphxAxis] || 0) - (a[dataGraphxAxis] || 0));

  const chartOptions = {
    chart: {
      type: "column",
      scrollablePlotArea: {
        minWidth: 800, // Scroll jika data banyak
      },
    },
    title: { text: title },
    xAxis: {
      categories: sortedData.map((item) => item[dataGraphSeries] || "N/A"),
      title: { text: columns[0] },
      labels: { rotation: -45, style: { fontSize: "10px" } }, // Rotasi untuk label panjang
    },
    yAxis: {
      min: 0,
      title: { text: "Jumlah Distribusi (Kg)" },
      labels: {
        formatter: function () {
          return this.value >= 1000000
            ? `${(this.value / 1000000).toFixed(1)}M`
            : this.value.toLocaleString();
        },
      },
    },
    series: [
      {
        name: "Jumlah",
        data: sortedData.map((item) => item[dataGraphxAxis] || 0),
      },
    ],
    tooltip: {
      formatter: function () {
        return `<b>${this.x}</b>: ${this.y.toLocaleString()} Kg`;
      },
    },
    plotOptions: {
      column: {
        dataLabels: {
          enabled: true,
          format: "{point.y:.0f}", // Tampilkan angka bulat
          style: { fontSize: "10px" },
        },
      },
    },
    exporting: {
      url: HIGHCHART_URL,
      enabled: true,
      showTable: true,
      },
  };

  return (
    <>
      <Card radius="sm" className="col-span-4">
        <CardHeader>
          <span className="text-primary text-xl font-bold">{title}</span>
        </CardHeader>
        <CardBody className="w-full">
          <HighchartsReact highcharts={Highcharts} options={chartOptions} />
        </CardBody>
      </Card>
      <div className="col-span-4 mt-5">
        <Table aria-label="Data Table">
          <TableHeader>
            {columns.map((col, idx) => (
              <TableColumn key={idx} className={kelasKolomDariData(dataKeys[idx], sortedData)}>
                {col}
              </TableColumn>
            ))}
          </TableHeader>
          <TableBody>
            {sortedData.map((item, index) => (
              <TableRow key={index}>
                {dataKeys.map((key, idx) => (
                  <TableCell key={idx} className={kelasKolom(key, item[key])}>
                    {key === "periode_bulan"
                      ? translateMonth(item[key]) || "N/A"
                      : isiSel(key, item[key])}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </>
  );
}


function renderMonthYearComparisonChartAndTable(data, title, columns, dataKeys, xAxisKey, valueKey) {
  const safeData = Array.isArray(data) ? data : [];

  // Kombinasi unik bulan dan tahun
  const uniqueSeries = Array.from(
    new Set(safeData.map((item) => `${item["periode_tahun"]}-${item["periode_bulan"]}`))
  ).sort((a, b) => a.localeCompare(b)); // Urutkan berdasarkan tahun-bulan

  // Grup data berdasarkan xAxisKey (misalnya company_name)
  const groupedData = safeData.reduce((acc, item) => {
    const groupKey = item[xAxisKey]; // Misalnya, company_name
    const seriesKey = `${item["periode_tahun"]}-${item["periode_bulan"]}`; // Kombinasi tahun-bulan
    if (!acc[groupKey]) acc[groupKey] = {};
    acc[groupKey][seriesKey] = parseFloat(item[valueKey]) || 0; // Nilai distribusi
    return acc;
  }, {});

  const chartOptions = {
    chart: { type: "column" },
    title: { text: title },
    xAxis: {
      categories: Object.keys(groupedData),
      title: { text: columns[2] },
      labels: { rotation: -45, style: { fontSize: "10px" } },
    },
    yAxis: {
      min: 0,
      title: { text: "Jumlah Distribusi" },
    },
    series: uniqueSeries.map((series) => ({
      name: `${translateMonth(series.split("-")[1])} ${series.split("-")[0]}`,
      data: Object.keys(groupedData).map(
        (group) => groupedData[group][series] || 0
      ),
    })),
    tooltip: {
      formatter: function () {
        return `<b>${this.series.name}</b><br>${this.x}: ${this.y.toLocaleString()} ${columns[3]}`;
      },
    },
    legend: { align: "center", verticalAlign: "top", layout: "horizontal" },
    plotOptions: {
      column: { dataLabels: { enabled: true } },
    },
    exporting: {
      url: HIGHCHART_URL,
      enabled: true,
      showTable: true,
      },
  };

  return (
    <>
      <Card radius="sm" className="col-span-4">
        <CardHeader>
          <span className="text-primary text-xl font-bold">{title}</span>
        </CardHeader>
        <CardBody className="w-full">
          <HighchartsReact highcharts={Highcharts} options={chartOptions} />
        </CardBody>
      </Card>
      <div className="col-span-4 mt-5">
        <Table aria-label="Data Table">
          <TableHeader>
            {columns.map((col, idx) => (
              <TableColumn key={idx} className={kelasKolomDariData(dataKeys[idx], safeData)}>
                {col}
              </TableColumn>
            ))}
          </TableHeader>
          <TableBody>
            {safeData.map((item, index) => (
              <TableRow key={index}>
                {dataKeys.map((key, idx) => (
                  <TableCell key={idx} className={kelasKolom(key, item[key])}>
                    {key === "periode_bulan"
                      ? translateMonth(item[key]) || "N/A"
                      : isiSel(key, item[key])}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </>
  );
}


// function renderMonthYearComparisonChartAndTable(  data,
//     title,
//     columns,
//     dataKeys,
//     xAxisKey,
//     valueKey) {
//     const safeData = Array.isArray(data) ? data : [];

//   // Buat daftar kombinasi unik bulan dan tahun
//   const uniqueSeries = Array.from(
//     new Set(safeData.map((item) => `${item["periode_tahun"]}-${item["periode_bulan"]}`))
//   ).sort((a, b) => a.localeCompare(b)); // Urutkan berdasarkan tahun-bulan

//   // Grup data berdasarkan xAxisKey (misalnya company_name)
//   const groupedData = safeData.reduce((acc, item) => {
//     const companyKey = item[xAxisKey]; // Misalnya, company_name
//     const seriesKey = `${item["periode_tahun"]}-${item["periode_bulan"]}`; // Kombinasi tahun-bulan
//     if (!acc[companyKey]) {
//       acc[companyKey] = {};
//     }
//     acc[companyKey][seriesKey] = parseFloat(item[valueKey]) || 0; // Nilai distribusi
//     return acc;
//   }, {});

//   // Siapkan data untuk BarChart
//   const chartData = {
//     xAxis: Object.keys(groupedData), // Nama perusahaan
//     series: uniqueSeries.map((series) => ({
//       name: `${translateMonth(series.split("-")[1])} ${series.split("-")[0]}`, // Nama seri (bulan dan tahun)
//       data: Object.keys(groupedData).map(
//         (company) => groupedData[company][series] || 0
//       ),
//     })),
//   };

//   return (
//     <>
//       <Card radius="sm" className="col-span-4">
//         <CardHeader>
//           <span className="text-primary text-xl font-bold">{title}</span>
//         </CardHeader>
//         <CardBody className="w-full flex flex-col items-center py-5 text-center">
//           <BarChart
//             xAxis={[
//               {
//                 scaleType: "band",
//                 data: chartData.xAxis, // Nama perusahaan sebagai X-Axis
//                 label: columns[2], // Label untuk X-Axis
//               },
//             ]}
//             series={chartData.series} // Data untuk setiap kombinasi bulan-tahun
//             height={300}
//             legend={{
//               show: true,
//               position: "top", // Letak legenda
//             }}
//             tooltip={{
//                 formatter: (params) => {
//                   const seriesIndex = params.seriesIndex;
//                   const seriesName = chartData.series[seriesIndex]?.name || "";
//                   return `${seriesName}: ${params.value} ${columns[3]}`; // Format tooltip dengan nama bulan-tahun dan nilai
//                 },
//               }}
            
//           />
//         </CardBody>
//       </Card>
//       <div className="col-span-4 mt-5">
//         <Table aria-label="Data Table">
//           <TableHeader>
//             {columns.map((col, idx) => (
//               <TableColumn key={idx}>{col}</TableColumn>
//             ))}
//           </TableHeader>
//           <TableBody>
//             {safeData.map((item, index) => (
//               <TableRow key={index}>
//                 {dataKeys.map((key, idx) => (
//                   <TableCell key={idx}>
//                     {key === "periode_bulan"
//                       ? translateMonth(item[key]) || "N/A"
//                       : item[key] || "N/A"}
//                   </TableCell>
//                 ))}
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </div>
//     </>
//   );
// }
  